<template>
  <div id="ledger_txs_by_type_container" v-bind:class="$mq">
    <div id="ledger_txs_by_type" v-show="have_txs">
      <p><b>Txs By Type</b></p>
      <hr/>

      <table style="text-align: right; width: 100%">
        <tr><td>{{payments.length}}</td><td>Payments</td></tr>
        <tr><td>{{offers.length}}</td><td>Offers</td></tr>
        <tr><td>{{escrows.length}}</td><td>Escrows</td></tr>
        <tr><td>{{account_sets.length}}</td><td>Account changes</td></tr>
        <tr><td>{{trust_sets.length}}</td><td>Trustlines set</td></tr>
      </table>

      <apexchart type=pie
                 v-bind:options="chart_options"
                 v-bind:series="chart_data"
                 height="250"
                 style="margin-top: 10px; padding-top: 20px; background: #eef1f6"/>
    </div>
  </div>
</template>

<script>
import config from '../config'

export default {
  name: 'LedgerTxsByType',

  props : {
    ledger : Object
  },

  computed : {
    have_txs : function(){
      return this.ledger.transactions;
    },

    txs : function(){
      return this.ledger.transactions || [];
    },

    payments : function(){
      return this.txs.filter(function(t){ return config.tx_category_for_type(t["TransactionType"]) == "payments" })
    },

    offers : function(){
      return this.txs.filter(function(t){ return config.tx_category_for_type(t["TransactionType"]) == "offers" });
    },

    escrows : function(){
      return this.txs.filter(function(t){ return config.tx_category_for_type(t["TransactionType"]) == "escrows" });
    },

    trust_sets : function(){
      return this.txs.filter(function(t){ return config.tx_category_for_type(t["TransactionType"]) == "trust_sets" });
    },

    account_sets : function(){
      return this.txs.filter(function(t){ return config.tx_category_for_type(t["TransactionType"]) == "account_sets" });
    },

    ///

    txs_by_type : function(){
      return {Payments : this.payments.length,
                Offers : this.offers.length,
               Escrows : this.escrows.length,
           AccountSets : this.account_sets.length,
             TrustSets : this.trust_sets.length }
    },

    chart_data : function(){
      return Object.values(this.txs_by_type);
    },

    chart_options : function(){
      return {labels: Object.keys(this.txs_by_type), legend: {position : 'bottom'}};
    }
  }
}
</script>

<style scoped>
#ledger_txs_by_type_container{
  background-color: white;
  min-height: 100%;
  border-left: 1px solid #cccccc;
}

#ledger_txs_by_type_container.sm,
#ledger_txs_by_type_container.md{
  border-top: 1px solid #cccccc;
  border-left: none;
}

#ledger_txs_by_type{
  padding: 10px;
  height: 100%;
}
</style>
